module.exports = __webpack_public_path__ + "static/media/upsell-benefit-filtered.03acc14c.svg";